// Postoje samo dve vrste obrasca: bez otkupnine i sa otkupninom.
export const POSTAL_FORM_TYPES = {
  BEZ_OTKUPNINE: 'bezOtkupnine',
  SA_OTKUPNINOM: 'saOtkupninom',
};

export const postalFormTypeOptions = [
  { value: POSTAL_FORM_TYPES.BEZ_OTKUPNINE, label: 'BEZ OTKUPNINE' },
  { value: POSTAL_FORM_TYPES.SA_OTKUPNINOM, label: 'SA OTKUPNINOM' },
];

export const getPostalFormTypeLabel = (type) =>
  postalFormTypeOptions.find((option) => option.value === type)?.label || '';

export const POSTAL_FORM_DELIVERY_WINDOWS = {
  UNTIL_12: 'until12',
  UNTIL_19: 'until19',
};

export const postalFormDeliveryWindowOptions = [
  { value: POSTAL_FORM_DELIVERY_WINDOWS.UNTIL_12, label: 'Do 12' },
  { value: POSTAL_FORM_DELIVERY_WINDOWS.UNTIL_19, label: 'Do 19' },
];

export const DEFAULT_POSTAL_FORM_DELIVERY_WINDOW =
  POSTAL_FORM_DELIVERY_WINDOWS.UNTIL_19;

export const POSTAL_FORM_PAYERS = {
  SENDER: 'sender',
  RECIPIENT: 'recipient',
};

export const postalFormPayerOptions = [
  { value: POSTAL_FORM_PAYERS.SENDER, label: 'Pošiljalac' },
  { value: POSTAL_FORM_PAYERS.RECIPIENT, label: 'Primalac' },
];

// Otkupnina se naplacuje od primaoca, pa je taj izbor unapred oznacen.
// Za obrazac bez otkupnine nista nije predlozeno - nacin placanja mora da se izabere.
export const getDefaultPostalFormPayer = (type) =>
  type === POSTAL_FORM_TYPES.SA_OTKUPNINOM
    ? POSTAL_FORM_PAYERS.RECIPIENT
    : null;

// Posiljalac je uvek isti, pa je popunjen u samom obrascu.
export const POSTAL_FORM_SENDER = {
  fullName: 'Snežana Milojević',
  street: 'NEBOJŠINA 24',
  postalCodeAndCity: '11000 Beograd',
  phone: '063/8400881',
};

export const POSTAL_FORM_CONTENT_DESCRIPTION = 'Kozmetika';
